function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e6e6e;stroke:#707070;stroke-width:0.2px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.1 -48.771)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 48.889)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M291.138,258.363a36.176,36.176,0,0,0-8.8.419.435.435,0,0,0,.079.862,34.965,34.965,0,0,1,8.662-.414.435.435,0,1,0,.054-.867Z",
  transform: "translate(-265.649 -246.143)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M291.138,300.192a36.173,36.173,0,0,0-8.8.419.435.435,0,0,0,.079.862,34.964,34.964,0,0,1,8.662-.414.435.435,0,1,0,.054-.867Z",
  transform: "translate(-265.649 -285.549)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M286.6,342.6a31.035,31.035,0,0,0-4.258.468.435.435,0,0,0,.079.862,31.922,31.922,0,0,1,4.218-.461.435.435,0,0,0-.039-.868Z",
  transform: "translate(-265.65 -325.585)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M65.516,296.749a34.765,34.765,0,0,1,8.662.414.435.435,0,0,0,.079-.862,36.189,36.189,0,0,0-8.8-.419.435.435,0,1,0,.054.867Z",
  transform: "translate(-61.285 -281.488)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M65.516,338.915a34.769,34.769,0,0,1,8.662.414.435.435,0,0,0,.079-.862,36.18,36.18,0,0,0-8.8-.419.435.435,0,1,0,.054.867Z",
  transform: "translate(-61.285 -321.211)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M65.516,254.584a34.765,34.765,0,0,1,8.662.414.435.435,0,0,0,.079-.862,36.183,36.183,0,0,0-8.8-.419.435.435,0,1,0,.054.867Z",
  transform: "translate(-61.285 -241.766)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M65.516,212.418a34.758,34.758,0,0,1,8.662.414.435.435,0,0,0,.079-.862,36.179,36.179,0,0,0-8.8-.419.435.435,0,1,0,.054.867Z",
  transform: "translate(-61.285 -202.043)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M65.516,170.252a34.767,34.767,0,0,1,8.662.414.435.435,0,0,0,.079-.862,36.182,36.182,0,0,0-8.8-.419.435.435,0,1,0,.054.867Z",
  transform: "translate(-61.285 -162.32)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M140.449,128.559a31.618,31.618,0,0,1,4.363.467.435.435,0,0,0,.079-.862,31.216,31.216,0,0,0-4.406-.474.435.435,0,1,0-.036.868Z",
  transform: "translate(-131.919 -123.125)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M27.9,50.939v-.526a1.366,1.366,0,0,0-1.24-1.353,32.922,32.922,0,0,0-11.657.735.613.613,0,0,1-.346,0A32.923,32.923,0,0,0,3,49.06a1.365,1.365,0,0,0-1.24,1.352v.526A1.932,1.932,0,0,0,0,52.984V69.026a3.207,3.207,0,0,0,3.2,3.2,36.026,36.026,0,0,1,10.13.483,6.457,6.457,0,0,0,3,0,33.291,33.291,0,0,1,9.865-.494,3.2,3.2,0,0,0,3.467-3.193V52.984A1.932,1.932,0,0,0,27.9,50.939ZM28.8,69.026a2.334,2.334,0,0,1-2.527,2.327,34.168,34.168,0,0,0-10.139.515,5.613,5.613,0,0,1-2.6,0A36.729,36.729,0,0,0,3.2,71.36,2.336,2.336,0,0,1,.869,69.026V52.984a1.024,1.024,0,0,1,.894-1.152v1.892a.435.435,0,1,0,.869,0V50.413a.491.491,0,0,1,.445-.487,32.1,32.1,0,0,1,11.321.7v19.41a3.748,3.748,0,0,1-.441-.077,34.875,34.875,0,0,0-10.8-.563.488.488,0,0,1-.528-.487V55.755a.435.435,0,0,0-.869,0V68.907A1.358,1.358,0,0,0,3.232,70.26a33.99,33.99,0,0,1,10.524.542,4.667,4.667,0,0,0,2.154,0,33.994,33.994,0,0,1,10.524-.542A1.358,1.358,0,0,0,27.9,68.907V67.088a.435.435,0,1,0-.869,0v1.819a.488.488,0,0,1-.528.487,34.874,34.874,0,0,0-10.8.563,3.744,3.744,0,0,1-.441.077V50.625a32.1,32.1,0,0,1,11.321-.7.491.491,0,0,1,.445.487V65.046a.435.435,0,1,0,.869,0V51.832a1.024,1.024,0,0,1,.894,1.152V69.026Z",
  transform: "translate(0 -48.889)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M290.039,102.665a34.447,34.447,0,0,0-7.55.382,1.2,1.2,0,0,0-.989,1.179v4.846a1.2,1.2,0,0,0,1.2,1.2,34.88,34.88,0,0,1,7.229-.347,1.2,1.2,0,0,0,1.254-1.2v-4.866A1.2,1.2,0,0,0,290.039,102.665Zm.272,6.062a.328.328,0,0,1-.343.328,34.982,34.982,0,0,0-7.217.341.328.328,0,0,1-.382-.324v-4.846a.327.327,0,0,1,.27-.323,33.593,33.593,0,0,1,7.357-.37.33.33,0,0,1,.315.328Z",
  transform: "translate(-265.19 -99.5)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M341.579,130.747l-1.811-1.274a.785.785,0,0,0-1.236.642v2.548a.785.785,0,0,0,1.236.642l1.811-1.274a.785.785,0,0,0,0-1.284ZM339.4,132.5v-2.222l1.58,1.111Z",
  transform: "translate(-318.917 -124.669)"
})));

function SvgTutorialsIconIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.866,
    height: 24.221,
    viewBox: "0 0 29.866 24.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialsIconIcon);
export default __webpack_public_path__ + "static/media/tutorials-icon-icon.46203149.svg";
export { ForwardRef as ReactComponent };